import React from 'react'
import { ToothSvg } from '../../../../../assets/icons'

function toothTopBack({ surface, tooth, handleClick }: { surface: any, tooth: any, handleClick: (e: any) => void }) {
  return (
    <div className="toothsvg">
      <ToothSvg color={surface[0]?.color} onClick={() => handleClick(
        surface ? surface[0] : surface === false
      )
      } />
      <ToothSvg color={surface[2]?.color} onClick={() => handleClick(
        surface ? surface[2] : surface === false
      )
      } />
      <ToothSvg color={surface[3]?.color} onClick={() => handleClick(
        surface ? surface[3] : surface === false
      )
      } />
      <ToothSvg color={surface[1]?.color} onClick={() => handleClick(
        surface ? surface[1] : surface === false
      )
      } />
      <div className="circle" style={{ background: surface[4]?.color }} onClick={() => handleClick(
        surface ? surface[4] : surface === false
      )
      }></div>
    </div>
  )
}

export default toothTopBack